import Shipments from "../../../containers/shipments/shipments";
import { getApiUrl } from "../../../utils/baseUrl";
import { filterTypeDictionary as filterType, analyticsTypeDictionary as analyticsType, autoSuggestLanguageDictionary as autosuggestLanguageOptions, categoryType, redirectingProfileEnum } from "../../../core/global/global-country-dictionary";
import { globalCountryDetailsDictionary as globalCountryDetails } from "../../../core/global/global-country-details";

export const analyticDropdownOptions = [
  { value: "shipments", label: "Number of Shipments", two_table_header: "Total Shipments" },
  { value: "value", label: "Shipment Value (USD)", two_table_header: "Total Shipment Value (USD)" },
  { value: "weight", label: "Total Weight (kg)", two_table_header: "Total Weight (kg)" },
];
export const trendsDropdownOptions = [
  { value: "shipments", label: "Shipments", table_header: "Total Shipments" },
  { value: "value", label: "Value (USD)", table_header: "Total Value (USD)" },
  { value: "weight", label: "Weight (kg)", table_header: "Total Weight (kg)" },
];

export const defaultData = {
  name: "Peru Imports",
  customShipmentGrid: true,
  showUiUeLevelTwo: true,
  isProductChemicalPresent: true,
  analyticsDefault: analyticDropdownOptions[0].value,
  isFilterGroupingPresent: true,
  isViewAllGridNew: true,
  exportPDFInAnalytics: false,
  analyticsRangeDownloadPresent: true,
  showUiTrends: true,
  trendsTableCompanyID: {
    shipper: "hashed_id",
    consignee: "hashed_id",
  },
  minimumDateAllowed: "2019-01-01",
  isImpExpGraph: true,
  isShipmentGridNew: true,
  isUIGridNew: true,
  isUEGridNew: true,
  importer_exporter_graph_sort__options: [
    { value: "shipment_value", label: "Value (USD)", table_header: "Total Value (USD)" },
    { value: "doc_count", value1: "date", label: "Shipments", table_header: "Total Shipments" },
    { value: "weight", label: "Weight (kg)", table_header: "Total Weight (kg)" },
  ],
  apiEndPoints: {
    getArrivalDate: getApiUrl("peruImportLatestArrivalDate"),
    getSearchResult: getApiUrl("peruImportSearch"),
    getAnalyticsData: getApiUrl("analytics/peruImportAnalytics"),
    saveProspectiveExportersApi: "addFavouriteCompany",
    saveProspectiveImportersApi: "addFavouriteCompany",
    downloadShipmentsApi: getApiUrl("create_excel_peru_imports"),
    downloadUniqueImporterExporter: getApiUrl("create_excel_peru_imports"),
    getShipmentByID: getApiUrl("peruImportShipmentByID"),
    getShipmentDownloadData: getApiUrl("renderToPdfPeruImports"),
    renderToPdfAnalytics: getApiUrl("renderToPdfAnalytics"),
    getUserPlanDetails: getApiUrl("getUserCreditsByPlan"),
    getCompanySlug: getApiUrl("companyProfiles/getSlug"),
    getSavedSearchPayloadById: getApiUrl("getSavedSearchPayloadById"),
    getMasterListsForAutoSearchFeilds: getApiUrl("dashboard/getMasterListsForAutoSearchFeilds"),
    getAnalyticsViewAll: getApiUrl("analytics/peruImportAnalyticsViewAll"),
    getMissingTabData: getApiUrl("intelSearchWhatAreMissing"),
    getImpExpGraphData: getApiUrl("importerExporterGraph"),
  },
  isAdvancedSearchAvailable: false,
  country_small: globalCountryDetails.pe_import.country_small,
  countryCaps: globalCountryDetails.pe_import.country_caps,
  product_id: globalCountryDetails.pe_import.product_id,
  compare_product_id: globalCountryDetails.pe_import.compareProduct,
  country_CamelCase: globalCountryDetails.pe_import.product_id,
  countryCode: globalCountryDetails.pe_import.countryCode,
  countryType: globalCountryDetails.pe_import.countryType,
  manyCountryType: globalCountryDetails.pe_import.manyCountryType,
  countryTypeCode: globalCountryDetails.pe_import.countryTypeCode,
  redirectionID: globalCountryDetails.pe_import.redirectionID,
  analyticsCountryID: globalCountryDetails.pe_import.analyticsCountryID,
  autoSuggestLanguage: autosuggestLanguageOptions.english,
  dateRangeHeading: "Date of Arrival",
  monthRangeHeading: "Month of Export",
  picker: {
    monthPicker: false,
    datePicker: true,
  },
  tabKeyWords: {
    shipments: true,
    analytics: true,
    exporters: false,
    importers: true,
    whatYouAreMissing: true,
  },
  main_dropdown_options: {
    entire_bill_of_lading: false,
    product_description: true,
    product_hscode: true,
    exporters: false,
    importers: true,
    allCategory: true,
    ports: true,
    chemical_description: true,
  },
  searchCategoryList: globalCountryDetails.pe_import.defaultDropDown,
  specialFields: {
    hscode: "hsCode",
    consignee: "derivedConsigneeMasterName",
    shipper: "derivedShipperMasterName",
    weight: "weight",
    teu: "teu",
    value: "shipmentValue",
    productCategory: "productCategory",
    sixDigitHsCode: "sixDigitHsCode",
    portOfLading: "standardLadingPortRegion",
    portOfUnlading: "standardUnladingPortName",
  },
  filterObj: {
    typeOfPayment: "typeOfPayment",
    financialEntity: "financialEntity",
    standardLadingPortRegion: "standardLadingPortRegion",
    countryOfOriginRegion: "countryOfOriginRegion",
    countryOfExporterRegion: "countryOfExporterRegion",
    countryOfDestinationRegion: "countryOfDestinationRegion",
    consignee: "consignee",
    isImporter: "isImporter",
    consigneeStateRegion: "consigneeStateRegion",
    consigneeCity: "consigneeCity",
    channelOfClearance: "channelOfClearance",
    standardUnladingPortName: "standardUnladingPortName",
    declarantEntityName: "declarantEntityName",
    carrierName: "carrierName",
    terminalName: "terminalName",
    weight: "weight",
    typeOfTreatment: "typeOfTreatment",
    shipmentValue: "shipmentValue",
    hsCode: "hsCode",
    derivedConsigneeMasterName: "derivedConsigneeMasterName",
    sixDigitHsCode: "sixDigitHsCode",
    productCategory: "productCategory",
    industryCategory: "industryCategory",
    consigneeJurisdictionCountryRegion: "consigneeJurisdictionCountryRegion",
    incoterm: "incoterm",
  },
  booleanFilterObj: {
    // include_master_bill: 'include_master_bill',
    // exclude_blank_consignee: 'exclude_blank_consignee',
    // exclude_blank_shipper: 'exclude_blank_shipper',
  },
  boxRangeFilterList: {
    weight: "weight",
    shipmentValue: "shipmentValue",
  },
  boxFilterObj: {
    weight: [],
    shipmentValue: [],
  },
  localisationFilterObj: {
    countryOfOriginRegion: "countryOfOrigin",
    consigneeStateRegion: "consigneeState",
    countryOfExporterRegion: "exporterCountry",
    countryOfDestinationRegion: "countryOfDestination",
    standardLadingPortRegion: "standardLadingPortName",
    consigneeJurisdictionCountryRegion: "consigneeJurisdictionCountry",
  },
  emptyFilterObj: {
    typeOfPayment: [],
    financialEntity: [],
    standardLadingPortRegion: [],
    countryOfOriginRegion: [],
    countryOfExporterRegion: [],
    countryOfDestinationRegion: [],
    consignee: [],
    isImporter: [],
    consigneeStateRegion: [],
    consigneeCity: [],
    channelOfClearance: [],
    standardUnladingPortName: [],
    declarantEntityName: [],
    carrierName: [],
    terminalName: [],
    weight: [],
    typeOfTreatment: [],
    shipmentValue: [],
    hsCode: [],
    sections: [],
    derivedConsigneeMasterName: [],
    sixDigitHsCode: [],
    productCategory: [],
    industryCategory: [],
    consigneeJurisdictionCountryRegion: [],
    incoterm: [],
  },
  defaultBooleanFilterObj: {
    // include_master_bill: true,
    // exclude_blank_consignee: false,
    // exclude_blank_shipper: false,
  },
  selectAll: {
    typeOfPayment: false,
    financialEntity: false,
    standardLadingPortRegion: false,
    countryOfOriginRegion: false,
    countryOfExporterRegion: false,
    countryOfDestinationRegion: false,
    consignee: false,
    isImporter: false,
    consigneeStateRegion: false,
    consigneeCity: false,
    channelOfClearance: false,
    standardUnladingPortName: false,
    declarantEntityName: false,
    carrierName: false,
    terminalName: false,
    weight: false,
    typeOfTreatment: false,
    shipmentValue: false,
    hsCode: false,
    sections: false,
    derivedConsigneeMasterName: false,
    sixDigitHsCode: false,
    productCategory: false,
    industryCategory: false,
    consigneeJurisdictionCountryRegion: false,
    incoterm: false,
  },
  specialMappingFields: {
    derived_hs_codes_string: {
      derived_hs_codes_string: {
        key: "derived_hs_codes_string",
        value: "",
      },
      derived_hs_codes_string_estimated: {
        key: "derived_hs_codes_string_estimated",
        value: "",
      },
      derived_hs_codes_string_estimated_is_present: {
        key: "derived_hs_codes_string_estimated_is_present",
        value: "Estimated HSCode",
      },
      fallback: "Not Available",
    },
    derived_shipment_value: {
      derived_shipment_value: {
        key: "derived_shipment_value",
        value: "",
      },
      derived_shipment_value_is_present: {
        key: "derived_shipment_value_is_present",
        value: "",
      },
      fallback: "Not Available",
    },
    shipper_party_name: {
      shipper_party_name: {
        key: "shipper_party_name",
        value: "",
      },
      fallback: "Not Declared",
    },
  },
  normalfilterList: [
    { heading: "Filter by Consignee Standardized Name", categoryName: categoryType.consigneeDetails, eventKey: "19", key: "derivedConsigneeMasterName", type: filterType.normalFilter, label: "Consignee Standardized Name", viewAllPlaceHolder: "Search in Consignee Standardized Name Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Consignee Name", categoryName: categoryType.consigneeDetails, eventKey: "1", key: "consignee", type: filterType.normalFilter, label: "Consignee Name", viewAllPlaceHolder: "Search in Consignee Name Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Consignee Type", categoryName: categoryType.consigneeDetails, eventKey: "2", key: "isImporter", type: filterType.normalFilter, label: "Consignee Type", viewAllPlaceHolder: "Search in Consignee Type Filter", emptyFilterText: "", searchFilterString: "", isTitleCase: true },
    { heading: "Filter by Consignee State", categoryName: categoryType.consigneeDetails, eventKey: "3", key: "consigneeStateRegion", altKey: "consigneeState", type: filterType.localizeFilter, label: "Consignee State", viewAllPlaceHolder: "Search in Consignee State Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Country Of Origin", categoryName: categoryType.shipperDetails, eventKey: "5", key: "countryOfOriginRegion", altKey: "countryOfOrigin", type: filterType.localizeFilter, label: "Country Of Origin", viewAllPlaceHolder: "Search in Country Of Origin Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Country of Export", categoryName: categoryType.shipperDetails, eventKey: "6", key: "countryOfExporterRegion", altKey: "exporterCountry", type: filterType.localizeFilter, label: "Country of Export", viewAllPlaceHolder: "Search in Country of Export Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Country of Import", categoryName: categoryType.consigneeDetails, eventKey: "6", key: "countryOfDestinationRegion", altKey: "countryOfDestination", type: filterType.localizeFilter, label: "Country of Import", viewAllPlaceHolder: "Search in Country of Import Filter", emptyFilterText: "", searchFilterString: "" },
    // { heading: "Filter by Financial Entity", categoryName: categoryType.ports, eventKey: '7', key: 'financialEntity', type: filterType.normalFilter, label: 'Financial Entity', viewAllPlaceHolder: 'Search in Financial Entity Filter', emptyFilterText: '', searchFilterString: '', },
    { heading: "Filter by Customs Office Name", categoryName: categoryType.ports, eventKey: "8", key: "standardUnladingPortName", type: filterType.normalFilter, label: "Customs Office Name", viewAllPlaceHolder: "Search in Customs Office Name Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Declarant Entity Name", categoryName: categoryType.ports, eventKey: "9", key: "declarantEntityName", type: filterType.normalFilter, label: "Declarant Entity Name", viewAllPlaceHolder: "Search in Declarant Entity Name Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Weight (kgs)", categoryName: categoryType.cargoDetails, eventKey: "12", key: "weight", type: filterType.boxFilter, label: "Weight (kgs)", viewAllPlaceHolder: "Search in Weight (kgs) Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Value (USD)", categoryName: categoryType.cargoDetails, eventKey: "14", key: "shipmentValue", type: filterType.boxFilter, label: "Value (USD)", viewAllPlaceHolder: "Search in Value (USD) Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Product Category", categoryName: categoryType.cargoDetails, eventKey: "15", key: "productCategory", type: filterType.normalFilter, label: "Product Category", viewAllPlaceHolder: "Search in Product Category Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Industry Group", categoryName: categoryType.cargoDetails, eventKey: "33", key: "industryCategory", type: filterType.normalFilter, label: "Industry Group", viewAllPlaceHolder: "Search in Industry Group Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by HS Code", categoryName: categoryType.cargoDetails, eventKey: "15", key: "hsCode", type: filterType.hsCodeFilter, label: "HS Code", viewAllPlaceHolder: "Search in HS Code Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Port of Lading", categoryName: categoryType.ports, eventKey: "18", key: "standardLadingPortRegion", altKey: "standardLadingPortName", type: filterType.localizeFilter, label: "Port of Lading", viewAllPlaceHolder: "Search in Port of Lading Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by 6 digit HS Code", categoryName: categoryType.cargoDetails, eventKey: "9", key: "sixDigitHsCode", type: filterType.normalFilter, label: "6 Digit HS Code", viewAllPlaceHolder: "Type to Search 6 digit HS Code", emptyFilterText: "", searchFilterString: "" },
    {
      heading: "Filter by Consignee Jurisdiction Country",
      categoryName: "consigneeDetails",
      eventKey: "25",
      key: "consigneeJurisdictionCountryRegion",
      altKey: "consigneeJurisdictionCountry",
      type: "localization-filter",
      label: "Consignee Jurisdiction Country",
      viewAllPlaceHolder: "Search Consignee Jurisdiction Country",
      emptyFilterText: "",
      searchFilterString: "",
    },
    { heading: "Filter by Incoterm", categoryName: categoryType.freightType, eventKey: "22", key: "incoterm", type: filterType.normalFilter, label: "Incoterm", viewAllPlaceHolder: "Search in Incoterm Filter", emptyFilterText: "", searchFilterString: "", isNoTransform: true },
  ],
  internalFilterList: [
    { isVisible: true, key: "uniqueImportExporterShipment" },
    { isVisible: true, key: "uniqueImportExporterWeight" },
    { isVisible: false, key: "uniqueImportExporterTeu" },
    { isVisible: true, key: "uniqueImportExporterValue" },
  ],
  highLightedColumnList: [
    { key: "declaration_number", label: "Declaration Number" },
    { key: "derived_financial_entity_name", label: "Financial Entity" },
    { key: "manifest_number", label: "Manifest Number" },
    { key: "shipment_bill_of_lading_number", label: "Bill Of Lading Number" },
    { key: "shipment_derived_foreign_shipping_port", label: "Port of Lading" },
    { key: "derived_shipment_country_of_origin", label: "Country Of Origin" },
    { key: "derived_shipment_country_of_exporter", label: "Country of Export" },
    { key: "importer_code", label: "Consignee RUC Number" },
    { key: "peru_importer_name", label: "Consignee Name" },
    { key: "derived_consignee_master_name", label: "Consignee Standardized Name" },
    { key: "peru_importer_address", label: "Peru Importer Address" },
    { key: "derived_consignee_province", label: "Consginee State" },
    { key: "derived_consignee_city", label: "Consignee City" },
    { key: "customs_office_name", label: "Customs Office Name" },
    { key: "customs_office_code", label: "Customs Office Code" },
    { key: "declarant_entity_name", label: "Declarant Entity Name" },
    { key: "transportation_company_name_or_code", label: "Carrier Name" },
    { key: "terminal_name", label: "Terminal Name" },
    { key: "derived_type_of_treatment", label: "Type Of Treatment" },
    { key: "shipment_hs_code", label: "HS Code" },
    { key: "shipment_description_of_goods", label: "Product Description (Spanish)" },
    { key: "derived_product_description_english", label: "Product Description" },
    { key: "derived_shipper_parent_company_name", label: "Shipper Parent Company" },
    { key: "derived_consignee_parent_company_name", label: "Consignee Parent Company" },
    { key: "derived_foreign_port_of_lading", label: "Port of Lading" },
    { key: "derived_customs_office_name", label: "Customs Office" },
  ],
  shipmentSorting: [
    { columnKey: "arrival_date", value: "date", isDefault: true },
    { columnKey: "derived_shipment_cif_amount_usd", value: "shipment_value", isDefault: false },
  ],
  exporterSorting: [
    { name: "Shipment Value", columnKey: "shipment_value", value: "shipment_value", isDefault: true },
    { name: "Shipments", columnKey: "doc_count", value: "date", isDefault: false },
    { name: "Weight", columnKey: "weight", value: "weight", isDefault: false },
  ],
  importerSorting: [
    { name: "Shipment Value", columnKey: "shipment_value", value: "shipment_value", isDefault: true },
    { name: "Shipments", columnKey: "doc_count", value: "date", isDefault: false },
    { name: "Weight", columnKey: "weight", value: "weight", isDefault: false },
  ],
  sortKeyMap: {
    date: "arrival_date",
    shipment_value: "derived_shipment_cif_amount_usd",
  },
  sortKeyUniqueImpExpMap: {
    shipment_value: "shipment_value",
    date: "doc_count",
    weight: "weight",
  },
  analyticsHeaderItems: [
    { label: "Total Number of Shipments", key: "total_shipments", valuePrefix: "", valueSuffix: "" },
    { label: "Total Shipments Value", key: "total_value", valuePrefix: "USD", valueSuffix: "" },
    { label: "Total Weight", key: "total_weight", valuePrefix: "", valueSuffix: "kg" },
  ],
  analyticsFieldsMapping: [
    { key: "trends", filterKey: "", label: "Import Trends", type: analyticsType.trends, showTrends: true, showlevelTwo: false },
    { key: "derived_shipment_country_of_origin", filterKey: "countryOfOriginRegion", label: "Countries of Origin", type: analyticsType.horizontalCountry, showTrends: true, showlevelTwo: true, defaultKey: "derived_shipment_country_of_exporter" },
    { key: "derived_shipment_country_of_exporter", filterKey: "countryOfExporterRegion", label: "Countries of Export", type: analyticsType.horizontalCountry, showTrends: true, showlevelTwo: true, defaultKey: "derived_shipment_country_of_origin" },
    { key: "derived_consignee_state", filterKey: "consigneeStateRegion", label: "Consignee States", type: analyticsType.horizontalBar, showTrends: true, showlevelTwo: true, defaultKey: "derived_shipment_country_of_origin" },
    { key: "derived_consignee_city", filterKey: "consigneeCity", label: "Consignee Cities", type: analyticsType.horizontalBar, showTrends: true, showlevelTwo: true, defaultKey: "derived_shipment_country_of_origin" },
    { key: "channel_of_clearance", filterKey: "channelOfClearance", label: "Channel Of Clearances", type: analyticsType.horizontalBar, showTrends: true, showlevelTwo: true, defaultKey: "derived_shipment_country_of_origin" },
    { key: "customs_office_name", filterKey: "standardUnladingPortName", label: "Customs Offices", type: analyticsType.horizontalBar, showTrends: true, showlevelTwo: true, defaultKey: "derived_shipment_country_of_exporter", profileType: redirectingProfileEnum.portOfUnlading.key },
    { key: "transportation_company_name_or_code", filterKey: "carrierName", label: "Carrier ", type: analyticsType.verticalBar, showTrends: true, showlevelTwo: true, defaultKey: "derived_shipment_country_of_origin" },
    { key: "terminal_name", filterKey: "terminalName", label: "Terminals ", type: analyticsType.verticalBar, showTrends: true, showlevelTwo: true, defaultKey: "derived_consignee_master_name" },
    { key: "hs_code", headerLabel: "HS Code", filterKey: "hsCode", label: "2-digit HS Codes", type: analyticsType.hsCode, showTrends: false, showlevelTwo: false },
    { key: "derived_trade_custom_office_origin_country", filterKey1: "countryOfOriginRegion", filterKey2: "standardUnladingPortName", label: "Trade Routes (Country of Origin -> Customs Office)", headerTwo: "Customs Office", headerOne: "Country of Origin", filterOne: "filterField1", filterTwo: "filterField2", keyOne: "field1Country", keyTwo: "field2Country", cityOne: "field1", cityTwo: "field2", keyOneCountryCode: "field1CountryCode", keyTwoCountryCode: "field2CountryCode", type: analyticsType.topTwo, showTrends: true, grpType: "multi", showlevelTwo: true, defaultKey: "transportation_company_name_or_code" },
    // { key: "derived_trade_custom_office_shipping_port", filterKey1: "standardLadingPortRegion", filterKey2: "standardUnladingPortName", label: "Trade Routes (Port of Lading -> Customs Office)", headerTwo: "Customs Office", headerOne: "Port of Lading", filterOne: "filterField1", filterTwo: "filterField2", keyOne: "field1Country", keyTwo: "field2Country", cityOne: "field1", cityTwo: "field2", keyOneCountryCode: "field1CountryCode", keyTwoCountryCode: "field2CountryCode", type: analyticsType.topTwo, showTrends: true, grpType: "multi", showlevelTwo: true, defaultKey: "transportation_company_name_or_code" },
    { key: "six_digit_hs_code", headerLabel: "6 digit HS Code", filterKey: "sixDigitHsCode", label: "6 digit HS Codes", type: analyticsType.hsCode, showTrends: true, showlevelTwo: true, defaultKey: "derived_consignee_master_name" },
  ],
  searchTableColumns: [
    { key: "", name: "View", selector: "", dataTip: "", type: "viewShipment", button: true, staticField: true, miWidth: "40px", maWidth: "40px" },
    { key: "s_no", name: "S No", selector: "s_no", dataTip: "", type: "", maxWidth: "84px !important", minWidth: "84px !important", grow: 0, wrap: true, staticField: true, miWidth: "60px", maWidth: "60px" },
    { key: "arrival_date", name: "Date Of Arrival", selector: "arrival_date", dataTip: "", type: "", dateFormat: "MMM DD, YYYY", sortable: true, grow: 1, wrap: true, miWidth: "110px", maWidth: "110px" },
    { key: "matched_column", name: "Matching Fields", selector: "matched_column", dataTip: "", type: "matchingField", grow: 1, wrap: true },
    { key: "shipment_hs_code", name: "HS Code", selector: "shipment_hs_code", dataTip: "", type: "", grow: 1, wrap: true, miWidth: "100px", maWidth: "100px" },
    { key: "shipment_description_of_goods", name: "Product", selector: "shipment_description_of_goods", tooltipValue: "shipment_description_of_goods", type: "", grow: 1, wrap: true, isSliceEnabled: true, sliceLength: 40 },
    { key: "shipment_quantity_of_packages", name: "Quantity", selector: "shipment_quantity_of_packages", secondarySelector: "", dataTip: "", type: "", grow: 0, wrap: true, isCommaFormat: true, fixedValueUpto: 2 },
    { key: "shipment_net_weight", name: "Net Weight", selector: "shipment_net_weight", secondarySelector: "", dataTip: "", type: "", grow: 0, wrap: true, isCommaFormat: true, fixedValueUpto: 2 },
    { key: "derived_consignee_master_name", name: "Consignee ", selector: "derived_consignee_master_name", alternateSelector: "peru_importer_name", id: "derived_consignee_master_company_id", dataTip: "", type: "companyRedirect", companyType: "I", grow: 1, wrap: true },
    { key: "derived_shipment_country_of_exporter", name: "Country of Export", selector: "derived_shipment_country_of_exporter", dataTip: "", type: "", grow: 1, wrap: true, miWidth: "100px", maWidth: "100px" },
    { key: "derived_shipment_cif_amount_usd", name: "Value (USD)", selector: "derived_shipment_cif_amount_usd", dataTip: "", type: "", sortable: true, grow: 1, wrap: true, isCommaFormat: true, fixedValueUpto: 2, miWidth: "100px", maWidth: "100px" },
  ],
  importerTableColumn: [
    { key: "id", showUiUeTwoLevel: false, name: "S No.", selector: "id", dataTip: "", type: "", button: true, staticField: true },
    { key: "key", name: "Company Name", selector: "key", selector1: "country", selector1Code: "country_code", selector2: "state", selector3: "address", id: "hashed_id", type: "companyRedirect", fixedLengthUptoRank: 30, fixedLengthUptoTrend: 28, minWidth: "275px" },
    { key: "ruc", showUiUeTwoLevel: false, name: "RUC", selector: "ruc", grow: 1, wrap: true },
    { key: "subKey", showUiUeTwoLevel: true, name: "Random Table", selector: "subKey", grow: 1, wrap: true },
    { key: "doc_count", name: "Shipments", selector: "doc_count", sortable: true, dataTip: "", type: "", grow: 1, isCommaFormat: true, fixedValueUpto: 2 },
    { key: "weight", name: "Net Weight (kg)", selector: "weight", sortable: true, dataTip: "", type: "", grow: 1, isCommaFormat: true, fixedValueUpto: 2 },
    { key: "shipment_value", name: "Value (USD)", selector: "shipment_value", sortable: true, dataTip: "", grow: 1, type: "", isCommaFormat: true, fixedValueUpto: 2 },
    { key: "oldest_shipment_date", name: "First Imported On", selector: "oldest_shipment_date", grow: 1, wrap: true },
    { key: "recent_shipment_date", name: "Last Imported On", selector: "recent_shipment_date", grow: 1, wrap: true },
    { key: "market_share", showUiUeTwoLevel: false, isNameVariable: true, name: "% share by", selector: "market_share", type: "", grow: 1, wrap: true },
  ],
  viewShipmentDetails: [
    {
      id: 1,
      title: "",
      growValue: 12,
      isHeader: true,
      imgUrl: "",
      data: [
        { label: "Declaration Number", value: "declaration_number" },
        { label: "Numbering Date", value: "numbering_date", dateFormat: true, monthFormat: false },
        { label: "Financial Entity", value: "derived_financial_entity_name", tooltip: true, tooltipField: "derived_financial_entity_code", tooltipPrefix: "Financial Entity Code: " },
        { label: "HS Code", value: "shipment_hs_code" },
      ],
    },
    {
      id: 2,
      title: "Shipment Origin Details",
      isConnectedColumn: true,
      isCompactHeader: true,
      growValue: 6,
      isHeader: false,
      imgUrl: "",
      data: [
        { label: "Port of Lading", value: "derived_foreign_port_of_lading", tooltip: true, tooltipField: "shipment_foreign_shipping_port", tooltipPrefix: "Shipment Port of Lading: ", type: false, redirectionID: "derived_port_of_lading_master_id", profileType: redirectingProfileEnum.portOfUnlading.key },
        { label: "Country Of Origin", value: "derived_shipment_country_of_origin", countryFlag: true, countryCodeField: "shipment_country_of_origin_code", tooltip: true, tooltipField: "shipment_country_of_origin_code", tooltipPrefix: "Shipment Country Of Origin Code: " },
        { label: "Country of Export", value: "derived_shipment_country_of_exporter", countryFlag: true, countryCodeField: "shipment_country_of_exporter_code" },
        // { label: 'Shipper Standardized Name', type: 'redirect', companyIdKey: 'derived_shipper_master_company_id', companyKey: 'shipper_name', derivedCompanyKey: 'derived_shipper_master_name' },
        // { label: 'Shipper address', value: 'shipper_address', },
        // { label: 'Shipper department', value: 'shipper_department', },
        // { label: 'Shipper State', value: 'shipper_state', },
        // { label: 'Shipper district', value: 'shipper_district', },
        // { label: 'Shipper Phone/Fax', value: 'shipper_phone', },
      ],
    },
    {
      id: 3,
      title: "Shipment Destination Details",
      growValue: 6,
      isHeader: false,
      isCompactHeader: true,
      imgUrl: "",
      data: [
        { label: "Consignee RUC Number", value: "importer_code" },
        { label: "Consignee Name", value: "peru_importer_name" },
        { label: "Consignee Standardized Name", type: "redirect", companyIdKey: "derived_consignee_master_company_id", companyKey: "", derivedCompanyKey: "derived_consignee_master_name" },
        { label: "Consignee Type", value: "derived_is_importer" },
        { label: "Country of Import", value: "derived_consignee_country" },
        { label: "Consignee Address", value: "peru_importer_address", isReadMore: true, readMoreLength: 45 },
        { label: "Consignee State", value: "derived_consignee_state" },
        {
          label: "Consignee Jurisdiction Country",
          value: "derived_consignee_jurisdiction_country",
          countryFlag: true,
          countryCodeField: "derived_consignee_jurisdiction_country_code",
        },
      ],
    },
    {
      id: 4,
      title: "Customs Details",
      growValue: 6,
      isHeader: false,
      imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251816/images/website/api-integration/ship-gray_1_jqiqaq.svg",
      data: [
        { label: "Customs Office Name", value: "derived_customs_office_name", type: false, redirectionID: "derived_port_of_unlading_master_id", profileType: redirectingProfileEnum.portOfUnlading.key },
        { label: "Customs Office Code", value: "customs_office_code" },
        { label: "Declarant Entity Name", value: "declarant_entity_name", tooltip: true, tooltipField: "declarant_entity_code", tooltipPrefix: "Declarant Entity Code: " },
      ],
    },
    {
      id: 5,
      title: "Cargo Details",
      growValue: 6,
      isHeader: false,
      imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251778/images/website/api-integration/delivery-box_1_1_niaysj.svg",
      data: [
        { label: "Item Number", value: "derived_item_number" },
        { label: "HS Code", value: "shipment_hs_code" },
        { label: "Product Description", value: "derived_product_description_english", isReadMore: true, readMoreLength: 45 },
        { label: "Product Description (Spanish)", value: "shipment_description_of_goods", isReadMore: true, readMoreLength: 45 },
        { label: "Net Weight", value: "shipment_net_weight", valueSuffix: " Kg" },
        { label: "Gross Weight", value: "shipment_gross_weight", valueSuffix: " Kg" },
        { label: "Quantity", value: "shipment_quantity_of_packages" },
        { label: "Total Physical Units", value: "shipment_physical_units" },
        { label: "Total Commercial Units", value: "shipment_commercial_unit" },
        { label: "Fob Value ", value: "shipment_fob_amount_usd", valuePrefix: "USD " },
        { label: "Freight ", value: "shipment_freight_value_usd", valuePrefix: "USD " },
        { label: "Insurance ", value: "shipment_insurance_value_usd", valuePrefix: "USD " },
        { label: "Adv", value: "adv" },
        { label: "Tax Amount", value: "shipment_tax_amount_usd", valuePrefix: "USD " },
        // { label: 'Commercial Unit', value: 'shipment_commercial_unit', },
        // { label: 'Ad Valorem Settlement Amount ', value: 'ad_valorem_settlement_amount_usd',valuePrefix: 'USD '  },
        // { label: 'Ad Valorem Release Amount ', value: 'ad_valorem_release_amount_usd', valuePrefix: 'USD ' },
        // { label: 'Ad Valorem To Pay Amount ', value: 'ad_valorem_release_amount_usd',valuePrefix: 'USD '  },
        // { label: 'Total Duties Taxes To Pay', value: 'total_duties_taxes_to_pay', },
        // { label: 'Total Taxes Duties Settlement Amount', value: 'derived_total_taxes_duties_settlement_amount', valuePrefix: 'USD ' },
        // { label: 'Due Date For Payment Of Duties', value: 'due_date_for_payment_of_duties',  },
        // { label: 'Quantity Of Packages', value: 'shipment_quantity_of_packages',  },
        // { label: 'Shipment Class Of Packages', value: 'shipment_class_of_packages',  },
        // { label: 'Shipment Physical Units', value: 'shipment_physical_units',  },
        // { label: 'Shipment Net Weight', value: 'shipment_net_weight',  },
        // { label: 'Shipment Gross Weight', value: 'shipment_gross_weight',  },
        // { label: 'Shipment Fob Amount', value: 'shipment_fob_amount_usd',  },
        // { label: 'Shipment Freight Value', value: 'shipment_freight_value_usd',  },
        // { label: 'Shipment Insurance Value', value: 'shipment_insurance_value_usd',  },
        // { label: 'Shipment Cif Amount ', value: 'derived_shipment_cif_amount_usd',  },

        // { label: 'Shipment Tax Amount', value: 'shipment_tax_amount_usd', valuePrefix: 'USD ' },
        // { label: 'Shipment Tax Amount Ipm', value: 'shipment_tax_amount_ipm',  },
        // { label: 'Shipment Tax Amount Isc', value: 'shipment_tax_amount_isc',  },
        // { label: 'Shipment Commercial Unit', value: 'shipment_commercial_unit',  },
      ],
    },
    {
      id: 6,
      title: "Declaration Number Details",
      growValue: 6,
      isHeader: false,
      imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251778/images/website/api-integration/delivery-box_1_1_niaysj.svg",
      data: [
        { label: "Total Net Weight", value: "net_weight_kgs", valueSuffix: " Kg" },
        { label: "Total Gross Weight", value: "gross_weight_kgs", valueSuffix: " Kg" },
        { label: "Total FOB Amount", value: "fob_value_amount_usd", valuePrefix: "USD " },
        { label: "Total CIF Amount", value: "cif_amount_usd", valuePrefix: "USD " },
        { label: "Total Freight", value: "freight_amount_usd", valuePrefix: "USD " },
        { label: "Total Insurance", value: "insurance_amount_usd", valuePrefix: "USD " },
      ],
    },
    // {
    //     id: 6,
    //     title: "Container Details",
    //     growValue: 12,
    //     isHeader: false,
    //     imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251816/images/website/api-integration/ship-gray_1_jqiqaq.svg",
    //     isContainer: true,
    //     mainKey: 'container_details',
    //     uniqueKey: 'id',
    //     data: [
    //         {
    //             title: "Container Identifiers",
    //             titleKey: '',
    //             isNested: false,
    //             nestedKey: "",
    //             uniqueKey: '',
    //             nestedNumber: '',
    //             childData: [
    //                 { label: 'Container Number', value: 'container_number', defaultValue: 'NA' },
    //                 { label: 'Seal Number', value: 'seal_number', defaultValue: 'NA' },
    //                 { label: 'Type of Service', value: 'type_of_service', defaultValue: 'NA' },
    //                 { label: 'Load Status', value: 'load_status', defaultValue: 'NA' },
    //                 { label: 'Marks & Numbers', value: 'marks_and_numbers', defaultValue: 'NA' },
    //                 { label: 'Equipment Desc.', value: 'equipment_description', defaultValue: 'NA' },
    //             ]
    //         },
    //         {
    //             title: "Container Dimension",
    //             titleKey: '',
    //             isNested: false,
    //             isContainerDimension: true,
    //             nestedKey: "",
    //             uniqueKey: '',
    //             nestedNumber: '',
    //             childData: [
    //                 { label: 'Length', value: 'length', defaultValue: 'NA', isFeet: true, isInch: true },
    //                 { label: 'Height', value: 'height', defaultValue: 'NA', isFeet: true, isInch: true },
    //                 { label: 'Width', value: 'width', defaultValue: 'NA', isFeet: true, isInch: true },
    //                 { label: 'Type', value: 'type', defaultValue: 'NA' }
    //             ]
    //         },
    //         {
    //             title: "Cargo Description",
    //             titleKey: '',
    //             isNested: true,
    //             nestedKey: "cargo_description_tables",
    //             nestedNumber: 'desc_seq_number',
    //             childData: [
    //                 { label: 'Piece Count', value: 'piece_count', defaultValue: 'NA', dynamicUnit: true, unitField: 'manifest_unit',},
    //                 { label: 'Description', value: 'cargo_description', defaultValue: 'NA', isReadMore: true, readMoreLength: 65,},
    //                 // { label: '', value: 'table', isTable: true, tableHeaderKey: ['HS Code', 'Value (USD)', 'Weight (kg)'], tableContentKey:['hscode', 'value', 'weight'] }
    //             ]
    //         },
    //         {
    //             title: "HAZMAT Sequence",
    //             titleKey: 'hazmat_sequence_number',
    //             isNested: true,
    //             nestedKey: "hazmat_sequence_tables",
    //             nestedNumber: 'hazmat_sequence_number',
    //             childData: [
    //                 { label: 'Sequence Number', value: 'hazmat_sequence_number', defaultValue: 'NA' },
    //                 { label: 'Code', value: 'hazmat_code', defaultValue: 'NA' },
    //                 { label: 'Class', value: 'hazmat_class', defaultValue: 'NA' },
    //                 { label: 'Code Qualifier', value: 'hazmat_code_qualifier', defaultValue: 'NA' },
    //                 { label: 'Contact', value: 'hazmat_contact', defaultValue: 'NA' },
    //                 { label: 'Flash Point Temp.', value: 'hazmat_flash_point_temperature', defaultValue: 'NA' },
    //                 { label: 'Flash Point Temp. Negative Ind', value: 'hazmat_flash_point_temperature_negative_ind', defaultValue: 'NA' },
    //                 { label: 'Flash Point Temp. Unit', value: 'hazmat_flash_point_temperature_unit', defaultValue: 'NA' },
    //                 { label: 'Description', value: 'hazmat_description', defaultValue: 'NA' },
    //                 { label: 'Classification', value: 'hazmat_classification', defaultValue: 'NA' },
    //             ]
    //         },
    //     ]
    // },
  ],
  defaultUeUiSecondLevelKey: "derived_shipment_country_of_origin",
  twoColumnMapping: {
    derived_shipment_country_of_origin: "Countries of Origin",
    derived_shipment_country_of_exporter: "Country of Export",
    derived_consignee_state: "Consignee States",
    derived_consignee_city: "Consignee Cities",
    customs_office_name: "Customs Office Names",

    derived_trade_custom_office_origin_country: "Trade Routes (Customs Office -> Country of Origin)",
    // derived_trade_custom_office_shipping_port: "Trade Routes (Customs Office -> Port of Lading)",
    derived_consignee_master_name: "Unique Importers",
    six_digit_hs_code: "6 digit HS Codes",
  },
};

const PeruImportSearch = () => {
  return <Shipments defaultData={defaultData} analyticDropdownOptions={analyticDropdownOptions} trendsDropdownOptions={trendsDropdownOptions} />;
};
export default PeruImportSearch;
